export default __webpack_public_path__ + "static/media/nftw.c2d458ce.gif";